import { request } from 'umi';
export async function checkPinStaff(params: any) {
  return request('/api/checkPinStaff/staffs', {
    method: 'POST',
    data: params,
  });
}
